import Bill from './styles'

export default Bill